import { render, staticRenderFns } from "./TimeBox.vue?vue&type=template&id=8f145370&scoped=true&"
import script from "./TimeBox.vue?vue&type=script&lang=js&"
export * from "./TimeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f145370",
  null
  
)

export default component.exports